import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-task-icon',
  template: `
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_17784_430)">
        <path
          d="M9.33333 20.0002H18.6667V22.6668H9.33333V20.0002ZM9.33333 14.6668H22.6667V17.3335H9.33333V14.6668ZM9.33333 9.3335H22.6667V12.0002H9.33333V9.3335ZM25.3333 4.00016H19.76C19.2 2.4535 17.7333 1.3335 16 1.3335C14.2667 1.3335 12.8 2.4535 12.24 4.00016H6.66667C6.48 4.00016 6.30667 4.0135 6.13333 4.0535C5.61333 4.16016 5.14667 4.42683 4.78667 4.78683C4.54667 5.02683 4.34667 5.32016 4.21333 5.64016C4.08 5.94683 4 6.2935 4 6.66683V25.3335C4 25.6935 4.08 26.0535 4.21333 26.3735C4.34667 26.6935 4.54667 26.9735 4.78667 27.2268C5.14667 27.5868 5.61333 27.8535 6.13333 27.9602C6.30667 27.9868 6.48 28.0002 6.66667 28.0002H25.3333C26.8 28.0002 28 26.8002 28 25.3335V6.66683C28 5.20016 26.8 4.00016 25.3333 4.00016ZM16 3.66683C16.5467 3.66683 17 4.12016 17 4.66683C17 5.2135 16.5467 5.66683 16 5.66683C15.4533 5.66683 15 5.2135 15 4.66683C15 4.12016 15.4533 3.66683 16 3.66683ZM25.3333 25.3335H6.66667V6.66683H25.3333V25.3335Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_17784_430">
          <rect width="32" height="32" fill="currentColor" />
        </clipPath>
      </defs>
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TaskIconComponent {}
